import Axios from "axios";
import {
  SET_PARTY_LIST,
  UNSET_PARTY_LIST,
} from "@/store/mutation-types";
import { getPartyList, syncPartyList } from "@/store/api";

// initial state
const state = {
  getPartyList: [],
};

const getters = {
  getPartyList(state) {
    return state.getPartyList;
  },
};

const mutations = {
  [SET_PARTY_LIST](state, data) {
    state.getPartyList = data;
  },
  [UNSET_PARTY_LIST](state) {
    state.getPartyList = [];
  },
};

const actions = {
  getPartyList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getPartyList)
        .then(function (response) {
          commit('SET_PARTY_LIST', response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PARTY_LIST');
          reject(error);
        });
    });
  },

  syncPartyList({ commit }) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.get(syncPartyList)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

